import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import LicenseForm from './LicenseForm';
import { useNavigate, useParams } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import licenseService from './licenseService';

const LicenseEdit = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const params = useParams();
  const [errors, setErrors] = useState<string[]>([]);
  const [entity, setEntity] = useState<any>({
    name: '',
    description: '',
    maxDevices: 0,
    includedModuleCodes: '',
  });
  const { canPlatform } = useCheckPermission();

  useEffect(() => {
    licenseService.get(params.id).then((response: any) => {
      if (response.hasError) {
        setErrors(response.errorMessages ?? []);
        enqueueSnackbar((response.errorMessages ?? []).join(','), {
          variant: 'error',
        });
      } else {
        setEntity(response.result);
      }
    });
  }, [params.id]);

  const onSubmit = (values: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    licenseService
      .update(values)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages ?? []);
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Success!', { variant: 'success' });
          navigate(-1);
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <LicenseForm
      entity={entity}
      readonly={!canPlatform(['ManageLicenses'])}
      onSubmit={onSubmit}
      handleCancel={() => navigate(-1)}
      errors={errors}
    />
  );
};

export default LicenseEdit;
